<template>
  <b-modal
    id="tabel-dinamis-data-cart-modal"
    hide-footer
    size="xl"
    header-class="td-bg-blue text-white"
    scrollable
  >
    <template #modal-title> <b-icon icon="cart2" /> Keranjang Data </template>

    <div style="overflow-y: scroll; max-height: 350px !important">
      <b-list-group v-if="selectedDataList.length > 0">
        <b-list-group-item v-for="(item, idx) in selectedDataList" :key="idx">
          <b-row class="mb-2">
            <b-col class="font-weight-bold" cols="1" v-if="item.selectedSubject"
              >Subjek</b-col
            >
            <b-col class="font-weight-bold" cols="1" v-else></b-col>
            <b-col
              class="font-weight-bolder"
              cols="10"
              v-if="item.selectedSubject"
            >
              {{ item.selectedSubject.name }}
            </b-col>
            <b-col class="font-weight-bold" cols="10" v-else></b-col>
            <b-col class="text-right" cols="1">
              <b-icon
                class="mr-4 td-text-blue"
                icon="pencil-square"
                scale="1.7"
                v-b-tooltip.left="'Ubah Data'"
                @click="editSelectedDataList(idx)"
                style="cursor: pointer"
              />
              <b-icon
                icon="trash2-fill"
                variant="danger"
                scale="1.7"
                v-b-tooltip.bottom="'Hapus Data'"
                @click="deleteSelectedDataList(idx)"
                style="cursor: pointer"
              />
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="font-weight-bold" cols="1">Dataset</b-col>
            <b-col class="font-weight-bolder" cols="10">{{
              item.selectedDataset.name
            }}</b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="font-weight-bold" cols="1">Indikator</b-col>
            <b-col class="font-weight-bolder" cols="10">
              <ol class="p-0 ml-3 my-0 mr-0" type="a">
                <li
                  class="mb-1"
                  v-for="(item2, idx2) in item.selectedIndicator"
                  :key="idx2"
                >
                  {{ item2.name }}
                </li>
              </ol>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="font-weight-bold" cols="1">Periode</b-col>
            <b-col
              class="font-weight-bolder"
              cols="10"
              v-html="constructPeriodDataList(item.selectedPeriod)"
            >
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="font-weight-bold" cols="1">Dimensi</b-col>
            <b-col class="font-weight-bolder" cols="10">
              <ol class="p-0 ml-3 my-0 mr-0" type="a">
                <template v-for="(item2, idx2) in item.selectedDimension">
                  <div class="mb-1" :key="idx2">
                    <li class="mb-3">
                      {{ capitalizeEachWord(item2.name) }}

                      <b-row class="my-1" v-if="item2.selectedProvince != null">
                        <b-col cols="2">Provinsi</b-col>
                        <b-col class="font-weight-bolder">
                          :
                          <span class="td-text-blue">
                            {{
                              capitalizeEachWord(item2.selectedProvince.name)
                            }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row class="my-1" v-if="item2.selectedDistrict != null">
                        <b-col cols="2">Kabupaten/Kota</b-col>
                        <b-col class="font-weight-bolder">
                          :
                          <span class="td-text-orange">
                            {{
                              capitalizeEachWord(item2.selectedDistrict.name)
                            }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row
                        class="my-1"
                        v-if="item2.selectedSubdistrict != null"
                      >
                        <b-col cols="2">Kecamatan</b-col>
                        <b-col class="font-weight-bolder">
                          :
                          <span class="td-text-teal">
                            {{
                              capitalizeEachWord(item2.selectedSubdistrict.name)
                            }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row
                        class="my-1"
                        v-if="item2.role.toLowerCase() === 'region'"
                      >
                        <b-col
                          cols="2"
                          v-html="regionName(item2.selectedRegionLevel)"
                        ></b-col>
                        <b-col class="font-weight-bolder">: </b-col>
                      </b-row>

                      <b-row>
                        <b-col
                          class="my-1 w-100"
                          style="
                            text-align: justify !important;
                            line-height: 1.5rem !important;
                            display: flex;
                            flex-wrap: wrap;
                            gap: 0.4rem;
                            font-size: 0.65rem;
                            min-width: 0px;
                            text-overflow: ellipsis;
                          "
                          v-html="
                            constructItemDimensionList(
                              item2.selectedItemDimension
                            )
                          "
                        >
                        </b-col>
                      </b-row>
                    </li>
                  </div>
                </template>
              </ol>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>

    <p
      class="my-5 w-100 text-center font-weight-normal"
      v-if="selectedDataList.length === 0"
    >
      <span
        >--Keranjang Data kosong, silahkan pilih data dari langkah
        pertama--</span
      >
    </p>

    <b-row class="mt-4 mb-3" align-h="center">
      <b-button
        class="td-btn td-btn-outline-red mr-1"
        @click="deleteAllSelectedDataList()"
        :disabled="selectedDataList.length < 1"
      >
        Hapus Semua Data
        <b-icon icon="trash" />
      </b-button>
      <b-button
        class="td-btn td-btn-blue ml-1"
        :disabled="selectedDataList.length < 1"
        @click="processTheCart()"
      >
        Proses Keranjang <b-icon icon="play-circle" />
      </b-button>
    </b-row>
  </b-modal>
</template>

<!-- javascript section-->
<script>
//import js modules section
import utils from "../../../../../utils/TabelDinamisUtils.js";
import store from "../../../../../store/TabelDinamisStoreV3.js";

//local registration for output component
export default {
  name: "DataCartModal",
  data() {
    return {
      selectedDataList: [],
      tdBgColor: ["td-bg-teal", "td-bg-orange", "td-bg-green", "td-bg-blue"],
    };
  },
  props: [
    "isChangeDataCart",
    "isEditSelectedData",
    "setIsStep2",
    "checkDisabledStep2",
  ],
  created() {},
  destroyed() {},
  mounted: function () {
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      if (modalId === "tabel-dinamis-data-cart-modal") {
        this.setSelectedDataList();
      }
    });
  },
  computed: {},
  watch: {
    selectedDataList: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.checkDisabledStep2();
        }
      },
    },
  },
  methods: {
    setSelectedDataList() {
      this.selectedDataList =
        store.getSelectedDataListLocalStorageByCurrentUsername() != null
          ? store.getSelectedDataListLocalStorageByCurrentUsername()[0].items
          : [];
    },

    constructPeriodDataList: function (val) {
      let valSize = val.length;

      return val.reduce((res, item, idx) => {
        if (idx === valSize - 1) {
          return res + item.periodName;
        } else {
          return res + item.periodName + ", ";
        }
      }, "");
    },

    constructItemDimensionList: function (val) {
      let i = 0;

      return val.reduce((res, item) => {
        let y =
          res +
          "<b-badge class='px-2 py-1 td-badge " +
          this.tdBgColor[i] +
          " text-light' >" +
          this.capitalizeEachWord(item.name) +
          "</b-badge>";

        if (i === 3) {
          i = 0;
        } else {
          i++;
        }

        return y;
      }, "");
    },

    capitalizeEachWord(str) {
      return utils.capitalizeEachWord(str);
    },

    editSelectedDataList(idx) {
      this.closeDataCart();
      utils.scrollIntoDiv("tabel-dinamis-progress-stepper-subject");
      this.$emit("update:idxSelectedData", idx);
      this.$emit("update:isEditSelectedData", true);
    },

    deleteSelectedDataList(idx) {
      store.clearSelectedDataListLocalStorageByCurrentUsername(idx);
      this.setSelectedDataList();
      this.$emit("update:isChangeDataCart", true);
    },

    deleteAllSelectedDataList() {
      store.clearAllSelectedDataListLocalStorageByCurrentUsername();
      this.setSelectedDataList();
      this.$emit("update:isChangeDataCart", true);
      this.checkDisabledStep2();
    },

    regionName: function (val) {
      switch (val) {
        case "NationalByProvince":
          return "Provinsi";

        case "ProvinceByDistrict":
          return "Kabupaten/Kota";

        case "DistrictBySubdistrict":
          return "Kecamatan";

        case "SubdistrictByVillage":
          return "Desa/Kelurahan";
      }
    },

    closeDataCart() {
      this.$bvModal.hide("tabel-dinamis-data-cart-modal");
    },

    processTheCart() {
      this.closeDataCart();
      this.setIsStep2(true);
      utils.scrollToUpperMost();
    },
  },
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 22-06-2022 -->
